import GoogleSignIn from './GoogleSignIn';
import React, { useState } from 'react';
import PasswordReset from './PasswordReset';
import './Auth.css';
import { GetAppQR } from './GetApp';

const API_URL = process.env.REACT_APP_BACKEND_URL || 'https://nethajiprime-backend.onrender.com';

function Login({ onLoginSuccess, onSwitchToSignup }) {
  const [showPasswordReset, setShowPasswordReset] = useState(false);
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const formBody = new URLSearchParams();
      formBody.append('username', formData.email);
      formBody.append('password', formData.password);
      const response = await fetch(`${API_URL}/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formBody,
      });
      const data = await response.json();
      if (!response.ok) {
        const detail = data.detail || '';
        if (response.status === 402 || detail.indexOf('Subscription required') === 0) {
          const parts = detail.split('|');
          const tempToken = parts[1] || '';
          if (tempToken) {
            localStorage.setItem('token', tempToken);
            localStorage.setItem('user', JSON.stringify({ id: parts[2]||'', email: parts[3]||formData.email, full_name: parts[4]||'' }));
            localStorage.setItem('np_force_pricing', '1');
            if (onLoginSuccess) onLoginSuccess({ id: parts[2]||'', email: parts[3]||formData.email, full_name: parts[4]||'' });
            return;
          }
        }
        throw new Error(detail || 'Login failed');
      }
      localStorage.setItem('token', data.access_token);
      localStorage.setItem('user', JSON.stringify(data.user));
      if (onLoginSuccess) onLoginSuccess(data.user);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  if (showPasswordReset) {
    return (
      <PasswordReset
        onBack={() => setShowPasswordReset(false)}
        onSuccess={() => {
          setShowPasswordReset(false);
          setError('');
          alert('✅ Password reset successful! Please login with your new password.');
        }}
      />
    );
  }

  return (
    <div className="auth-page">
      <div className="auth-container">
        {/* Logo */}
        <div className="auth-header">
          <div className="auth-logo">🎬</div>
          <h1>NETHAJI PRIME</h1>
          <h2>Welcome Back</h2>
          <p>Sign in to continue watching</p>
        </div>

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="your@email.com"
              required
              autoFocus
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <div style={{ position: 'relative' }}>
              <input
                type={showPassword ? 'text' : 'password'}
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Your password"
                required
                style={{ paddingRight: '48px', width: '100%', boxSizing: 'border-box' }}
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', color: '#aaa', cursor: 'pointer', fontSize: '16px', padding: '0' }}
              >
                {showPassword ? '🙈' : '👁️'}
              </button>
            </div>
          </div>

          <div className="forgot-password">
            <button type="button" onClick={() => setShowPasswordReset(true)}>
              Forgot Password?
            </button>
          </div>

          {error && (
            <div className="error-message">❌ {error}</div>
          )}

          <GoogleSignIn onSuccess={(data)=>{localStorage.setItem('token',data.access_token);localStorage.setItem('user',JSON.stringify(data.user));if(onLoginSuccess)onLoginSuccess(data.user);}} onError={(e)=>setError(e)} />
          <div style={{textAlign:"center",color:"rgba(255,255,255,0.4)",fontSize:"12px",margin:"12px 0"}}>— or sign in with email —</div>
          <button type="submit" className="auth-submit-btn" disabled={loading}>
            {loading ? '⏳ Signing in...' : '🔐 Login'}
          </button>
        </form>

        <div className="auth-footer">
          <p>
            Don't have an account?{' '}
            <button type="button" className="auth-link" onClick={onSwitchToSignup}
              style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
              Sign Up Free
            </button>
          </p>
          <p style={{ color: '#666', fontSize: '12px', marginTop: '8px' }}>
            7-day free trial • No credit card required
          </p>
        </div>

        <div style={{ borderTop: '1px solid rgba(255,255,255,0.08)', marginTop: '18px', paddingTop: '18px' }}>
          <div style={{ color: 'rgba(255,255,255,0.55)', fontSize: '12px', fontWeight: 700, marginBottom: '10px', textAlign: 'center' }}>
            &#128241; Get the Nethaji Prime app
          </div>
          <GetAppQR size={120} />
        </div>
      </div>
    </div>
  );
}

export default Login;

